class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}  

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
     this.refreshRecommendations();
      const cartItemsWrapper = document.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper');
if (cartItemsWrapper && cartItemsWrapper.getAttribute('data-gift') === 'ture' && cartItemsWrapper.getAttribute('data-gift-added') != 'true') {
  const GiftButton = document.querySelector('#gift_add_wrapper #ProductSubmitButton-'); if (GiftButton) { GiftButton.click();}
}

  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble1',
        section: 'cart-icon-bubble1',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if(errors){
        errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
     const quantityInputs = document.querySelectorAll('.quantity__input.yardage_input');
quantityInputs.forEach((input) => {
  const currentValue = parseFloat(input.value);
  input.value = (currentValue / 2).toString();
});
        this.disableLoading(line);
      });
  
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
        this.refreshRecommendations();
       const cartItemsWrapper = document.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper');
if (cartItemsWrapper && cartItemsWrapper.getAttribute('data-gift') === 'ture' && cartItemsWrapper.getAttribute('data-gift-added') != 'true') {
  console.log(true);
   const GiftButton = document.querySelector('#gift_add_wrapper #ProductSubmitButton-'); if (GiftButton) { GiftButton.click();}
}
if (cartItemsWrapper && cartItemsWrapper.getAttribute('data-gift') === 'false') {
  console.log(false);
  const removeGiftButton = document.querySelector('.remove-gift-button'); if (removeGiftButton) { removeGiftButton.click(); }
}
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
 refreshRecommendations() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
const cartPriceBubble = document.getElementById('cart-price-bubble');
const totalPrice = (data.total_price / 100).toFixed(2);
cartPriceBubble.innerHTML = `<span>$${totalPrice}</span>`;
      let latestItemId;
      for (const item of data.items) {
        if (item.final_price > 0) {
          latestItemId = item.product_id;
          break;
        }
      }
      if (!latestItemId) {
        // Clear content and move drawer off-screen
        const drawerSidebar = document.getElementById('drawer_sidebar');
        if(drawerSidebar){
        drawerSidebar.innerHTML = '';
        drawerSidebar.style.transform = 'translateY(100%)'; // Note: 'transform' not 'Transform'
        }
        fetch("/discount/CLEAR");
        throw new Error('Empty Cart, No Recomendations');
      }
      // Fetch product recommendations based on the latest product ID
      return fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${latestItemId}&limit=4&intent=related`);
    })
    .then(response => response.json())
    .then(({ products }) => {
      const recommendationsHTML = this.buildRecommendationsHTML(products);
       const drawerSidebar = document.getElementById('drawer_sidebar');
        if(drawerSidebar){
        drawerSidebar.innerHTML = recommendationsHTML;
        }
    })
    .catch(error => {
      console.error('Error:', error);
    });
}
// Helper function to build HTML content from product recommendations
 buildRecommendationsHTML(products) {
  if (products.length === 0) {
    return '<p>No recommendations available.</p>';
  }
function formatPrice(priceInCents) {
  return (priceInCents / 100).toFixed(2);
}
  return `
    <h3 class="drawer__related-products-heading p3-b text-center">Recommended for you</h3>
    <div class="splide">
      <div class="splide__track">
        <ul class="splide__list">
          ${products.map(product => `
            <li class="splide__slide">
              <div class="card-wrapper product-card-wrapper underline-links-hover">
                <div class="card card--standard card--media" style="--ratio-percent: 100%;">
                  <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
                    <div class="card__media">
                      <div class="media media--transparent media--hover-effect">
                        <img srcset="${product.featured_image}" src="${product.featured_image}" sizes="${product.featured_image.sizes}" alt="${product.title}" class="motion-reduce" loading="lazy" width="1000" height="1000">
                      </div>
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading h5">
                        <a href="${product.url}" class="full-unstyled-link" aria-labelledby="CardLink-cart-recommendations-${product.id}">
                          ${product.title}
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
             <div class="precut_button--wrapper">
                      <a href="${product.url}" class="pcollection_card--title">
                      <button
                        class="general_button"
                      >
                       Make Selection
                      </button>
                      </a>
                    </div>
              
            </li>
          `).join('')}
        </ul>
      </div>
    </div>
  `;
}
}

customElements.define('cart-items', CartItems);
class QuantityHandler extends HTMLElement {
  constructor() {
    super();
    this.decrementButton = this.querySelector('.ubtn_dec');
    this.incrementButton = this.querySelector('.ubtn_inc');
    this.loader = this.querySelector('.qty_spinner');
    this.quantityInput = this.querySelector('.bundle_quantity_input');
    this.cartItemRow = this.closest('.cart-item');
    this.minusButton = this.cartItemRow.querySelector('[name="minus"]');
    this.plusButton = this.cartItemRow.querySelector('[name="plus"]');
    this.spinner = this.cartItemRow.querySelector('.loading__spinner');
    this.productqty = this.cartItemRow.querySelector('[data-id]').dataset.qty;
    this.decrementButton.addEventListener('click', this.onDecrementClick.bind(this));
    this.incrementButton.addEventListener('click', this.onIncrementClick.bind(this));
  }

  onDecrementClick() {
    const currentValue = parseFloat(this.quantityInput.value);
    if (currentValue > 0.5) {
      this.quantityInput.value = (currentValue - 0.25);
      this.decrementButton.style.pointerEvents = "none";
      this.spinner.classList.remove('hidden');
      this.loader.classList.remove('hidden');
      updateCartAjax(this.cartItemRow, this.quantityInput.value, -1);
      
    } else {
      this.decrementButton.style.pointerEvents = "none";
    }
  }

  onIncrementClick() {
    
    const currentValue = parseFloat(this.quantityInput.value);
    if (currentValue * 4 < this.productqty) {
      this.incrementButton.style.pointerEvents = "none";
      this.quantityInput.value = (currentValue + 0.25);
      this.spinner.classList.remove('hidden');
       this.loader.classList.remove('hidden');
      updateCartAjax(this.cartItemRow, this.quantityInput.value, 1);
    } else {
      this.cartItemRow.querySelector('.cart-item__error-text').textContent = 'Max limit reached';
      this.incrementButton.style.pointerEvents = "none";
      this.spinner.classList.add('hidden');
      return;
    }
  }
  
}

customElements.define('quantity-handler', QuantityHandler);
if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
